// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcr_a bhs_a bhs_r bhs_j","ModeratorInvitationListItem__left":"bcr_b bhs_a bhs_j","ModeratorInvitationListItem__note":"bcr_c bhs_fo"};